import config from './config.js';
import observeResources from './observeResources.js';

export default function collectResources(window, performance, PerformanceObserver, entryType, filter, debounce = config.resourceDebounce) {
    return (new Promise(resolve => {
        const resources = [];

        let id = setTimeout(done, debounce);

        const observer = observeResources(PerformanceObserver, (entries, finish) => {
            entries = entries.filter(filter);
            if (entries.length) {
                resources.push(...entries);
                clearTimeout(id);
                id = setTimeout(() => {
                    done();
                    finish();
                }, debounce);
            }
        });

        function done() {
            if (observer && observer.takeRecords) {
                resources.push(...observer.takeRecords());
            }
            resolve(resources);
        }
    })).then(resources => {
        if (!resources.length) {
            return {
                entryType,
                count: 0
            };
        }

        const {round, max} = Math;

        const {tbd, firstResponse, lastResponse} = resources.reduce((acc, {transferSize, responseStart, responseEnd}) => ({
            tbd: acc.tbd + transferSize,
            firstResponse: responseStart > 0 && responseStart < acc.firstResponse ? responseStart : acc.firstResponse,
            lastResponse: max(acc.lastResponse, responseEnd)
        }), {
            tbd: 0,
            firstResponse: Number.MAX_SAFE_INTEGER,
            lastResponse: 0
        });

        const ttfbs = resources
            .filter(({requestStart}) => typeof requestStart === 'number')
            .map(({requestStart, responseStart}) => responseStart - requestStart)
            .sort();
        const {length} = ttfbs;
        const half = length >> 2;

        const count = resources.length;
        const result = {
            entryType,
            count,
            startTime: round(firstResponse),
            duration: round(lastResponse - firstResponse),
            mttfb: round(length % 2 ? ttfbs[half] : (ttfbs[half - 1] + ttfbs[half]) / 2),
            attfb: round(ttfbs.reduce((acc, ttfb) => acc + ttfb, 0) / length)
        };
        if (!Number.isNaN(tbd)) {
            result.tbd = tbd;
            result.detail = `${count} (${tbd >> 10} KB)`;
        }
        return result;
    }, () => ({
        entryType,
        count: 0
    }));
}
